import { render, staticRenderFns } from "./Bdr2026DictionarySidebar.vue?vue&type=template&id=3ae974cd&"
import script from "./Bdr2026DictionarySidebar.vue?vue&type=script&lang=js&"
export * from "./Bdr2026DictionarySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports